import {
    Component,
    OnInit,
    Input,
    OnChanges,
    SimpleChanges,
    EventEmitter,
    Output,
} from '@angular/core';
import { take } from 'rxjs/operators';
import { RtJeopardizedShipment, RtTrip } from '@bds/railtrac-models';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { RailtracTripService } from '../../../railtrac-trip/railtrac-trip.service';
import { RailtracClmService } from '@bds/railtrac';
import { faBroomWide } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'rt-jeopardized-shipment-no-bill',
    templateUrl: './rt-jeopardized-shipment-no-bill.component.html',
    styleUrls: ['./rt-jeopardized-shipment-no-bill.component.scss'],
})
export class RtJeopardizedShipmentNoBillComponent implements OnInit, OnChanges {
    @Input() shipment: RtJeopardizedShipment;
    public trip: RtTrip;
    isSaving = false;
    iconTrash = faBroomWide;
    @Output() change = new EventEmitter();

    constructor(
        public tripService: RailtracTripService,
        public clmService: RailtracClmService,
        public snackbar: MatSnackBar,
        public dialog: MatDialog,
    ) {}

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        const shipment = changes['shipment'];
        if (!!shipment.currentValue) {
            const cv: RtJeopardizedShipment = shipment.currentValue;
            this.tripService.findCurrentTrip(cv.carInitials, cv.carNumber).subscribe((trip) => {
                this.trip = trip;
            });
        }
    }

    onPopoutTripclicked($event: number) {}

    onResolve(event: string) {
        // TODO: Based on setup, not sure how to get trip
    }

    onTripSaveClicked(tripDetails: RtTrip) {
        this.tripService.update(tripDetails.ormId, tripDetails).subscribe((upTrip) => {
            this.snackbar.open('Trip Saved!', 'Ok', {
                duration: 3000,
            });
        });
    }

    /**
     * Clears the CLM event for the specified trip.
     * @param trip The trip for which to clear the CLM event.
     */
    clearClmEvent(trip: RtTrip): void {
        this.isSaving = true;

        this.clmService
            .getClmsForTrip(trip.ormId)
            .pipe(take(1))
            .subscribe({
                next: (clms) => {
                    const noBillClm = clms.find((clm) => clm.clmEvent === 'NO BILL');

                    if (!noBillClm) {
                        this.isSaving = false;
                        this.snackbar.open('No "NO BILL" CLM event found for this trip!', 'Error', {
                            duration: 3000,
                        });
                        return;
                    }

                    this.clmService
                        .clearClmEvents([noBillClm.ormId])
                        .pipe(take(1))
                        .subscribe({
                            next: () => {
                                this.snackbar.open('CLM Event Cleared!', 'Ok', { duration: 3000 });
                                this.change.emit();
                                this.isSaving = false;
                            },
                            error: () => {
                                this.snackbar.open('Clear CLM Event Failed!', 'Error', {
                                    duration: 3000,
                                });
                                this.isSaving = false;
                            },
                            complete: () => {
                                this.isSaving = false;
                            },
                        });
                },
                error: () => {
                    this.isSaving = false;
                    this.snackbar.open('Failed to fetch CLMs!', 'Error', { duration: 3000 });
                },
                complete: () => {
                    this.isSaving = false;
                },
            });
    }
}
